/** ACRA Information on Corporate Entities (collection 2) — letter bucket → dataset ID. */
export const ACRA_CORPORATE_COLLECTION_ID = '2';

export const ACRA_BUCKET_DATASET_IDS: Record<string, string> = {
  A: 'd_8575e84912df3c28995b8e6e0e05205a',
  B: 'd_3a3807c023c61ddfba947dc069eb53f2',
  C: 'd_c0650f23e94c42e7a20921f4c5b75c24',
  D: 'd_acbc938ec77af18f94cecc4a7c9ec720',
  E: 'd_124a9bd407c7a25f8335b93b86e50fdd',
  F: 'd_4526d47d6714d3b052eed4a30b8b1ed6',
  G: 'd_b58303c68e9cf0d2ae93b73ffdbfbfa1',
  H: 'd_fa2ed456cf2b8597bb7e064b08fc3c7c',
  I: 'd_85518d970b8178975850457f60f1e738',
  J: 'd_478f45a9c541cbe679ca55d1cd2b970b',
  K: 'd_5573b0db0575db32190a2ad27919a7aa',
  L: 'd_a2141adf93ec2a3c2ec2837b78d6d46e',
  M: 'd_9af9317c646a1c881bb5591c91817cc6',
  N: 'd_67e99e6eabc4aad9b5d48663b579746a',
  O: 'd_5c4ef48b025fdfbc80056401f06e3df9',
  P: 'd_181005ca270b45408b4cdfc954980ca2',
  Q: 'd_4130f1d9d365d9f1633536e959f62bb7',
  R: 'd_2b8c54b2a490d2fa36b925289e5d9572',
  S: 'd_df7d2d661c0c11a7c367c9ee4bf896c1',
  T: 'd_72f37e5c5d192951ddc5513c2b134482',
  U: 'd_0cc5f52a1f298b916f317800251057f3',
  V: 'd_e97e8e7fc55b85a38babf66b0fa46b73',
  W: 'd_af2042c77ffaf0db5d75561ce9ef5688',
  X: 'd_1cd970d8351b42be4a308d628a6dd9d3',
  Y: 'd_31af23fdb79119ed185c256f03cb5773',
  Z: 'd_4e3db8955fdcda6f9944097bef3d2724',
  Others: 'd_300ddc8da4e8f7bdc1bfc62d0d99e2e7',
};

/** Societies, charities, co-ops, etc. (non-ACRA issuance agencies). */
export const OTHER_UEN_BUCKET_KEY = 'OtherAgencies';
export const OTHER_UEN_AGENCIES_DATASET_ID = 'd_b1d2b840ab9e993570c037b706b39bb8';

/** All buckets synced into crm.acra_entities (corporate + other agencies). */
export const ACRA_SYNC_BUCKET_DATASET_IDS: Record<string, string> = {
  ...ACRA_BUCKET_DATASET_IDS,
  [OTHER_UEN_BUCKET_KEY]: OTHER_UEN_AGENCIES_DATASET_ID,
};

/** Corporate letter buckets only — used for SSIC / corporate catalogue loops. */
export const ACRA_RICH_DATASET_IDS = Object.values(ACRA_BUCKET_DATASET_IDS);

const STOP_WORDS = new Set([
  'pte', 'ltd', 'limited', 'company', 'co', 'enterprise', 'enterprises', 'the', 'and', 'group',
  'holding', 'private', 'inc', 'llc', 'pl', 'sdn', 'bhd',
]);

function normName(value: string): string {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function looksLikeUen(query: string): boolean {
  const q = query.trim().toUpperCase();
  return /^[0-9]{8,9}[A-Z]$/.test(q) || /^[ST][0-9]{2}[A-Z]{2}[0-9]{4}[A-Z]$/.test(q);
}

export function resolveAcraBucketKey(query: string): string {
  const norm = normName(query);
  for (const token of norm.split(' ')) {
    if (token.length >= 2 && !STOP_WORDS.has(token.toLowerCase())) {
      const letter = token[0];
      if (letter >= 'A' && letter <= 'Z') return letter;
    }
  }
  const firstAlpha = norm.match(/[A-Z]/);
  if (firstAlpha) return firstAlpha[0];
  return 'Others';
}

export function acraBucketDatasetId(query: string): string {
  const key = resolveAcraBucketKey(query);
  return ACRA_BUCKET_DATASET_IDS[key] ?? ACRA_BUCKET_DATASET_IDS.Others;
}
